import {
  ensureDeskBillingRecord,
  freezeBillingForUser as freezeBillingRecord,
  getAccount,
  listAccounts,
  resumeBillingForUser as resumeBillingRecord,
  subscriptionFor,
} from "../accounts/store.js";

export const USER_SUSPENSION_DAYS = 90;
export const ADMIN_SUSPENSION_DAYS = 180;

export function journeyUserIdForAccount(account) {
  return account?.journey_user_id || account?.id || "";
}

export function accountForUserId(userId) {
  if (!userId) return null;
  return (
    getAccount(userId) ||
    listAccounts().find((row) => row.journey_user_id === userId) ||
    null
  );
}

export function suspensionLimitDays(actor) {
  if (actor?.role === "admin" || actor?.role === "broker") return ADMIN_SUSPENSION_DAYS;
  return USER_SUSPENSION_DAYS;
}

export function freezeBillingForUser(userId, options = {}) {
  if (!userId) return null;
  const account = accountForUserId(userId);
  const session = account
    ? { userId: journeyUserIdForAccount(account) || userId, role: account.role, email: account.email }
    : { userId, role: "agent" };
  ensureDeskBillingRecord(session);
  return freezeBillingRecord(account?.id || userId, options);
}

export function resumeBillingForUser(userId, options = {}) {
  if (!userId) return null;
  const account = accountForUserId(userId);
  return resumeBillingRecord(account?.id || userId, options);
}

export function billingFreezeSummary(userId) {
  const account = accountForUserId(userId);
  const ownerId = account?.id || userId;
  const sub = subscriptionFor(ownerId);
  if (!sub) return { frozen: false };
  return {
    frozen: Boolean(sub.billing_frozen),
    frozenAt: sub.billing_frozen_at || "",
    anchorDate: sub.billing_anchor_date || sub.renewal_date || "",
    renewalDate: sub.renewal_date || "",
    reason: sub.billing_frozen_reason || "",
    status: sub.status,
  };
}

